import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const IA_TABS = [
  { key: 'from', label: 'Expéditeur' },
  { key: 'subject', label: 'Objet' },
  { key: 'html', label: 'HTML' },
  { key: 'text', label: 'Texte' },
];

function IAICon() {
  // Icône simple pour la démo, vous pouvez remplacer par une icône "spark" IA
  return (
    <svg height={18} width={18} viewBox="0 0 24 24" fill="#a56dff">
      <circle cx={12} cy={12} r={10} fill="#a56dff" opacity="0.13" />
      <path d="M12 7v5l4 2" stroke="#a56dff" strokeWidth="2" fill="none" />
    </svg>
  );
}

export default function AIBroadcastStickyHeader({ tab, setTab }) {
  const { broadcastId, playlistId } = useParams();
  const [broadcastName, setBroadcastName] = useState('');
  const navigate = useNavigate();
  const token = localStorage.getItem('prae.jwt');

  useEffect(() => {
    async function fetchBroadcast() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/broadcasts/${broadcastId}`,
          {
            headers: {
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
              'Content-Type': 'application/json',
            },
          }
        );

        if (res.ok) {
          const data = await res.json();
          setBroadcastName(data.name || '');
        }
      } catch (e) {
        console.error('Erreur lors de la récupération du broadcast:', e);
      }
    }
    fetchBroadcast();
  }, [broadcastId]);

  return (
    <div
      className="AIBroadcastHeaderSticky sticky z-50 flex items-center justify-between px-6 bg-white border-b border-t border-stone-200"
      style={{ top: 64, minHeight: 48 }}
    >
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate('/broadcasts/playlists/' + playlistId)}
          className="p-2 rounded-xl bg-white text-gray-950 font-bold text-sm hover:bg-black hover:text-white transition"
          title="Retour aux broadcasts"
        >
          <FaArrowLeft />
        </button>
        <span className="text-lg text-gray-950 font-bold truncate max-w-[40vw]">
          {broadcastName || <span className="text-[#9ea0b3]">Chargement…</span>}
        </span>
      </div>
      <div className="flex gap-1 items-center">
        {IA_TABS.map(btn => (
          <button
            key={btn.key}
            onClick={() => setTab(btn.key)}
            className={`flex items-center gap-2 px-3 py-2 rounded-xl font-semibold transition text-sm ${
              tab === btn.key
                ? 'bg-[#a56dff] text-white shadow'
                : 'bg-[#eceaff] text-[#23223a] hover:bg-[#e5e0ff]'
            }`}
            style={{ minWidth: 80 }}
          >
            <IAICon />
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
}
